var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5C2.05228 9.5 2.5 8.82843 2.5 8C2.5 7.17157 2.05228 6.5 1.5 6.5C0.947715 6.5 0.5 7.17157 0.5 8C0.5 8.82843 0.947715 9.5 1.5 9.5Z",
    fill: "#D7E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5C5.05228 5 5.5 4.32843 5.5 3.5C5.5 2.67157 5.05228 2 4.5 2C3.94772 2 3.5 2.67157 3.5 3.5C3.5 4.32843 3.94772 5 4.5 5Z",
    fill: "#D7E0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5C10.0523 5 10.5 4.32843 10.5 3.5C10.5 2.67157 10.0523 2 9.5 2C8.94772 2 8.5 2.67157 8.5 3.5C8.5 4.32843 8.94772 5 9.5 5Z",
    fill: "#D7E0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5C13.0523 9.5 13.5 8.82843 13.5 8C13.5 7.17157 13.0523 6.5 12.5 6.5C11.9477 6.5 11.5 7.17157 11.5 8C11.5 8.82843 11.9477 9.5 12.5 9.5Z",
    fill: "#D7E0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 11.38 8.38 12 7 12C5.62 12 4 11.38 4 10C4 8.62 5 6.5 7 6.5C9 6.5 10 8.62 10 10Z",
    fill: "#D7E0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5C2.05228 9.5 2.5 8.82843 2.5 8C2.5 7.17157 2.05228 6.5 1.5 6.5C0.947715 6.5 0.5 7.17157 0.5 8C0.5 8.82843 0.947715 9.5 1.5 9.5Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5C5.05228 5 5.5 4.32843 5.5 3.5C5.5 2.67157 5.05228 2 4.5 2C3.94772 2 3.5 2.67157 3.5 3.5C3.5 4.32843 3.94772 5 4.5 5Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5C10.0523 5 10.5 4.32843 10.5 3.5C10.5 2.67157 10.0523 2 9.5 2C8.94772 2 8.5 2.67157 8.5 3.5C8.5 4.32843 8.94772 5 9.5 5Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5C13.0523 9.5 13.5 8.82843 13.5 8C13.5 7.17157 13.0523 6.5 12.5 6.5C11.9477 6.5 11.5 7.17157 11.5 8C11.5 8.82843 11.9477 9.5 12.5 9.5Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 11.38 8.38 12 7 12C5.62 12 4 11.38 4 10C4 8.62 5 6.5 7 6.5C9 6.5 10 8.62 10 10Z",
    stroke: "#4147D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaw);
export default __webpack_public_path__ + "static/media/icon-paw.8f45efff45328f6daf3842c5e001bea9.svg";
export { ForwardRef as ReactComponent };